import { Grid, TextField } from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';

import { type ScheduleDataType } from './types';

export type CollectableDeliveryFieldErrors = {
  supplier: boolean;
  delivererName: boolean;
  receiverName: boolean;
};

type DeliveryFieldKey = keyof CollectableDeliveryFieldErrors;

interface DeliveryAndCollectionFieldsProps {
  scheduleData: ScheduleDataType;
  setScheduleData: Dispatch<SetStateAction<ScheduleDataType>>;
  fieldErrors: CollectableDeliveryFieldErrors;
  setFieldErrors: Dispatch<SetStateAction<CollectableDeliveryFieldErrors>>;
}

function requiredHelperText(label: string, hasError: boolean) {
  return hasError ? `${label} is required` : '';
}

export default function DeliveryAndCollectionFields({
  scheduleData,
  setScheduleData,
  fieldErrors,
  setFieldErrors,
}: DeliveryAndCollectionFieldsProps) {
  const updateField = (key: DeliveryFieldKey, value: string) => {
    setScheduleData((prev) => ({ ...prev, [key]: value }));
    setFieldErrors((prev) => ({ ...prev, [key]: false }));
  };

  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid size={12}>
        <TextField
          label="Supplier *"
          value={scheduleData.supplier ?? ''}
          onChange={(e) => updateField('supplier', e.target.value)}
          size="small"
          fullWidth
          error={fieldErrors.supplier}
          helperText={requiredHelperText('Supplier', fieldErrors.supplier)}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          label="Deliverer Name *"
          value={scheduleData.delivererName ?? ''}
          onChange={(e) => updateField('delivererName', e.target.value)}
          size="small"
          fullWidth
          error={fieldErrors.delivererName}
          helperText={requiredHelperText('Deliverer', fieldErrors.delivererName)}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          label="Receiver Name *"
          value={scheduleData.receiverName ?? ''}
          onChange={(e) => updateField('receiverName', e.target.value)}
          size="small"
          fullWidth
          error={fieldErrors.receiverName}
          helperText={requiredHelperText('Receiver', fieldErrors.receiverName)}
        />
      </Grid>
    </Grid>
  );
}
